module.exports = __webpack_public_path__ + "static/media/5f_website_logo_diamond_ms.9668fbbb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/5f_website_logo_diamond_ms.jpg
// module id = 90
// module chunks = 0